export enum BasketKind {
  /** Marketplace reward item.  */
  Reward,
  /** Portal product purchase.  */
  PortalProduct,
  /** Member account top-up.  */
  TopUpMember,
  /** Junior membership addition.  */
  Junior,
  /** Stored payment card token registration.  */
  CardToken,
  /** Member benefit item.  */
  Benefit,
  /** Registration payment — excluded from API response.  */
  RegistrationPayment,
}

export enum OrderPurchaseStatus {
  /** Item has been created */
  Created = 1,
  /** Item has been cancelled */
  Cancelled = 2,
  /** Item has failed to be completed */
  Failed = 3,
  /** Item was part of a partial success */
  Partial = 4,
  /** Successfully completed */
  Completed = 5,
  /** Item has been refunded */
  Refunded = 6,
  /** Item has been called back */
  CalledBack = 7,
  /** Item call back has failed */
  CalledBackFailed = 8,
  /** Item has not been completed because more information is required */
  RequireMoreInformation = 9,
  /** Item was refunded by the customer */
  RefundedByCustomer = 10,
  /** Item has been transfered */
  Transfered = 11,
}

export interface OrderDetails {
  OrderId: string;
  Points: number;
  TotalAmount: number;
  ShippingAmount: number;
  TaxAmount: number;
  EcashAmount: number;
  Basket: OrderBasketDetails[];
  Status: OrderPurchaseStatus;
}

export enum BasketItemType {
  All = 0,
  ResaleTicket = 1,
  TopUpMember = 3,
  Reward = 4,
  PortalProduct = 19,
  CardToken = 24,
  Junior = 25,
  Benefit = 27,
}

export enum MarketplaceSubType {
  MarketplaceItem = 0,
  UniqueCode = 1,
  DownloadLink = 2,
  Event = 3,
  MerchantItem = 4,
  VirtualEvent = 5,
}

export type BasketItemSubType = number | MarketplaceSubType;

export interface OrderBasketItem {
  Image: string;
  Title: string;
  Description: string;
  Id: number;
  Points: number;
  Merchant: number;
  Ecash: number;
  Quantity: number;
  Status: OrderPurchaseStatus;
  ItemType: BasketItemType;
  SubItemType: BasketItemSubType;
  AttributeName: string;
  AttributeValue: string;
  CustomFields: { CustomFieldId: number, DisplayName: string, Value: string }[];
}

export interface OrderBasketDetails {
  BasketKind: BasketKind;
  Items: OrderBasketItem[];
}
